import script from "./BlogsList.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogsList.vue?vue&type=script&setup=true&lang=js"

import "./BlogsList.vue?vue&type=style&index=0&id=037f37a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-037f37a4"]])

export default __exports__